import { render, staticRenderFns } from "./TypeALaCarte.vue?vue&type=template&id=3b961bdb&scoped=true"
import script from "./TypeALaCarte.vue?vue&type=script&lang=js"
export * from "./TypeALaCarte.vue?vue&type=script&lang=js"
import style0 from "./TypeALaCarte.vue?vue&type=style&index=0&id=3b961bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b961bdb",
  null
  
)

export default component.exports